import React from 'react';
import { motion } from 'framer-motion';
import { HardHat, Camera, Layout, Palette, Rocket, Instagram, MessageCircle } from 'lucide-react';
import { agencyInfo } from '../data/mock';

const milestones = [
  { icon: HardHat, label: 'Bastidores da Construção' },
  { icon: Camera, label: 'Escolha dos Equipamentos' },
  { icon: Layout, label: 'Montagem dos Cenários' },
  { icon: Palette, label: 'Desenvolvimento da Identidade' },
  { icon: Rocket, label: 'Preparação para o Lançamento' },
];

const StudioConstruction = () => {
  const openWpp = () => {
    window.open(
      `https://wa.me/${agencyInfo.whatsapp}?text=${encodeURIComponent(
        'Olá! Quero acompanhar as novidades do Coutin Studio.'
      )}`,
      '_blank'
    );
  };

  return (
    <section
      id="construcao"
      data-testid="studio-construction"
      className="relative py-24 md:py-32 border-t border-white/5 bg-[#0B0B0F] overflow-hidden"
    >
      <div className="container mx-auto px-6 lg:px-12 relative z-10 max-w-6xl">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-start"
        >
          {/* Left copy */}
          <div className="lg:col-span-5">
            <span className="text-[10px] md:text-xs uppercase tracking-[0.4em] font-bold text-[#F59E0B] mb-4 inline-block">
              Acompanhe a Construção
            </span>
            <h2 className="font-display text-3xl md:text-5xl lg:text-6xl font-black text-[#F5F5F0] leading-[1.05] mb-6">
              Você vai ver o Coutin Studio{' '}
              <span className="text-[#2540A3] italic">nascer</span>.
            </h2>
            <p className="text-base md:text-lg text-[#A1A1AA] font-light leading-relaxed mb-8">
              Novidades sobre a construção, cenários, equipamentos e o
              desenvolvimento da marca — publicados nos nossos canais oficiais.
            </p>

            <div className="flex flex-wrap gap-3">
              <a
                href={`https://instagram.com/${agencyInfo.instagram.replace('@', '')}`}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="construction-instagram"
                className="inline-flex items-center gap-2 px-5 py-3 rounded-lg border border-white/15 hover:border-[#F59E0B] hover:bg-[#F59E0B]/10 text-[#F5F5F0] text-sm font-bold uppercase tracking-wide transition-all duration-300"
              >
                <Instagram className="w-4 h-4 text-[#F59E0B]" />
                Instagram
              </a>
              <button
                onClick={openWpp}
                data-testid="construction-whatsapp"
                className="inline-flex items-center gap-2 px-5 py-3 rounded-lg bg-[#2540A3] hover:bg-[#1A3690] text-white text-sm font-bold uppercase tracking-wide shadow-[0_15px_40px_-15px_rgba(37,64,163,0.6)] transition-all duration-300"
              >
                <MessageCircle className="w-4 h-4" />
                WhatsApp
              </button>
            </div>
          </div>

          {/* Right — Timeline */}
          <div className="lg:col-span-7 relative">
            <div className="absolute left-5 top-3 bottom-3 w-px bg-gradient-to-b from-[#2540A3] via-[#2540A3]/30 to-transparent" />
            <ul className="space-y-4">
              {milestones.map((m, i) => {
                const Icon = m.icon;
                return (
                  <motion.li
                    key={i}
                    initial={{ opacity: 0, x: 16 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true, amount: 0.2 }}
                    transition={{ duration: 0.4, delay: i * 0.08 }}
                    data-testid={`milestone-${i}`}
                    className="relative flex items-center gap-5 pl-1"
                  >
                    <div className="w-10 h-10 rounded-full bg-[#0B0B0F] border-2 border-[#2540A3] flex items-center justify-center shrink-0 shadow-[0_0_20px_-5px_rgba(37,64,163,0.6)]">
                      <Icon className="w-4 h-4 text-[#2540A3]" strokeWidth={2.2} />
                    </div>
                    <span className="text-base md:text-lg text-[#F5F5F0] font-medium">
                      {m.label}
                    </span>
                  </motion.li>
                );
              })}
            </ul>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default StudioConstruction;
